import { EP_ADMIN_ACCOUNTS, EP_CHANGE_PASSOWRD, EP_CHANGE_USERNAME, EP_CREATE_ACCOUNT } from '../constants/endpointConstants';
import api from './Api';

const changePassword = async (userId, oldPassword, newPassword) => {
    const response = await api.post(EP_CHANGE_PASSOWRD, { userId, oldPassword, newPassword });
    return response.data;
};

const getAdminAccounts = async () => {
    const response = await api.get(EP_ADMIN_ACCOUNTS);
    return response.data;
}

const createAccount = async (username, email, password) => {
    const response = await api.post(EP_CREATE_ACCOUNT, { username, email, password });
    return response.data;
};

export {changePassword, getAdminAccounts, createAccount}